import { useContext } from 'react';

import { CartContext } from '@/components/providers';

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) throw Error('useCart must be used within CartProvider');
  return context;
};
